import { useSpring, animated } from '@react-spring/web'
import { useEffect } from "react";

export function RevealAnimation({children, direction='up', delay=0}) {

    let fromX = 20;
    let toX = 0;
    let fromY = 20;
    let toY = 0;

    const from = { 
        opacity: 0, 
    };
    
    const to = { 
        opacity: 1, 
    };

    const properties = {
        from: from,
        to: to
    }


    if ( direction === 'up' || direction === 'down' ) {
        if ( direction === 'down' ) {
            fromY = -20;
        }

        from.y = fromY;
        to.y = toY;
        
    }

    if ( direction === 'left' || direction === 'right' ) {
        if ( direction === 'right' ) {
            fromX = -20;
        }

        from.x = fromX;
        to.x = toX;
    }

    if ( typeof delay === 'number' && delay > 0  ) {
        properties.delay = delay;
    }

    const props = useSpring(properties);

    return <animated.div style={props}>{children}</animated.div>
}

export function FormReveal({children, delay=0, className='form-wrapper form-reveal-wrapper', replay=false, reverse=false}) {
    useEffect(() => {
        if ( replay ) {
            triggerReplay();
        } 
    }, [replay]);

    const from = { 
        y: -5,
        opacity: 0,
    };
    
    const to = { 
        y: 0,
        opacity: 1
    };

    const properties = {
        from: from,
        to: to,
        config: {
            tension: 250,
            friction: 16,
        },
    }

    if ( reverse ) {
        properties.from = to;
        properties.to = from;
    }

    if ( typeof delay === 'number' && delay > 0  ) {
        properties.delay = delay;
    }
    
    const triggerReplay = () => {
        api.start({
            ...properties,
            reset: true
        });
    };

    const [styleProps, api] = useSpring(() => (properties));

    return <animated.div style={styleProps} className={className}>{children}</animated.div>
}

export function FadeInGrow({children}) {
    const props = useSpring({
        from: { 
                opacity: 0, 
                scale: 0, 
        },
        to: { 
                opacity: 1, 
                scale: 1,
        },
    });

    return <animated.div style={props}>{children}</animated.div>
}

export function Fade({children, direction='out'}) {

    const from = { 
        opacity: 1, 
    };
    
    const to = { 
        opacity: 0, 
    };

    const properties = {
        from: from,
        to: to,
        config: { duration: 175 }
    }


    if ( direction === 'in' ) {
        from.opacity = 0;
        to.opacity = 1;

    }

    const props = useSpring(properties);

    return <animated.div style={props}>{children}</animated.div>
}

export function Rotate({children}) {
    const props = useSpring({
        from: { 
                opacity: 0, 
                transform: 'rotate(-155deg)',
        },
        to: { 
                opacity: 1, 
                transform: 'rotate(360deg)'
        },
        config: {duration: 500}
    });

    return <animated.div style={props}>{children}</animated.div>
}

export function InViewTest({children}) {
    const props = useSpring({
        from: { 
                opacity: 0, 
                y: 20 
        },
        to: { 
                opacity: 1, 
                y: 0 
        },
    });

    return <animated.div style={props}>{children}</animated.div>
}

export function TabReveal({replay=false, children}) {
    useEffect(() => {
        if ( replay ) {
            triggerReplay();
        } 
    }, [replay]);

    const [styleProps, api] = useSpring(() => ({
        from : { opacity: 0 },
        to: { opacity: 1 },
    }));

    const triggerReplay = () => {
        api.start({
            from : { opacity: 0 },
            to: { opacity: 1 },
            reset: true
        });
    };

    return <animated.div style={styleProps} className="tab-reveal">{ children}</animated.div>
}

export function calculateAnimationDelay(index, delay=200) {
    return index * delay;
}

export function AnimatedProgressCircle({children, targetAngle=360}) {
    const props = useSpring({
            from: { angle: 0 },
            to: async (next) => {
            await next({ angle: targetAngle });
        },
        config: { duration: 600 },
    });

  return (
    <animated.div
        className="animation workout-progress__circle"
        style={{
            background: props.angle.to((a) => `conic-gradient(var(--progress-fill-color, #000) ${a}deg, var(--progress-empty-color, #fff) 0deg)`),
        }}
    >
        {children}
    </animated.div>
  );
}

export function Toast({replay=false, children, customClass='', reverse=false}) {
    useEffect(() => {
        if ( replay ) {
            triggerReplay();
        } 
    }, [replay]);

    const from = { x: -10, opacity: 0 };
    const to = { x:0, opacity: 1 };

    const properties = {
        from: from,
        to: to,
    }

    if ( reverse ) {
        properties.from = to;
        properties.to = from;
    }

    const triggerReplay = () => {
        api.start({
            ...properties,
            reset: true
        });
    };

    const [styleProps, api] = useSpring(() => (properties));

    return <animated.div style={styleProps} className={`toast ${customClass}`}>{ children }</animated.div>
}

export default AnimatedProgressCircle;